import axios from "axios";

export const getWorkoutPagesData = async (url: string): Promise<Uint8Array> => {
  const cloudDisplayConfigData = (
    await axios.get(url, {
      responseType: "arraybuffer",
    })
  ).data;
  return new Uint8Array(cloudDisplayConfigData);
};
